import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';
import { CartControllerGetDiscountResponse } from '../../responses/cart-controller-get-discount.response';

interface CartControllerGetDiscountRequestBody {
  code: string;
  tenantId: string;
}

interface CartControllerGetDiscountOpenApiParameters {
  requestBody: CartControllerGetDiscountRequestBody;
}

@OpenApiMethod({
  method: HttpMethods.POST,
  apiName: 'customer',
  path: '/cart/discount',
  operationId: 'CartController_getDiscount',
  parameters: [],
})
export class CartControllerGetDiscountMethod
  extends BaseOpenApiMethod<CartControllerGetDiscountResponse>
  implements Method<CartControllerGetDiscountResponse, CartControllerGetDiscountOpenApiParameters>
{
  public call(parameters: CartControllerGetDiscountOpenApiParameters): Promise<CartControllerGetDiscountResponse> {
    return super.call(parameters);
  }
}
